const LogoutIcon = ({ darkMode }) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${darkMode ? 'text-white' : 'text-[#27292C]'} mr-4 h-6`}
  >
    <path
      d="M11.8544 12.59L14.4444 10H4.77441V8H14.4444L11.8544 5.41L13.2744 4L18.2744 9L13.2744 14L11.8544 12.59ZM16.7744 0C17.3048 0 17.8136 0.210714 18.1886 0.585786C18.5637 0.960859 18.7744 1.46957 18.7744 2V6.67L16.7744 4.67V2H2.77441V16H16.7744V13.33L18.7744 11.33V16C18.7744 16.5304 18.5637 17.0391 18.1886 17.4142C17.8136 17.7893 17.3048 18 16.7744 18H2.77441C1.66441 18 0.774414 17.1 0.774414 16V2C0.774414 0.89 1.66441 0 2.77441 0H16.7744Z"
      fill="currentColor"
    />
  </svg>
)

export default LogoutIcon
